<template>
  <div>
    <el-dialog
      :visible.sync="addServiceDialog"
      width="50%"
      title="配资计划"
      :close-on-click-modal="false"
    >
      <el-form :model="form" label-width="auto" :rules="rules" ref="mapForm">
        <el-form-item label="方案名称" prop="plan_name">
          <el-input v-model="form.plan_name" placeholder="方案名称"></el-input>
        </el-form-item>
        <el-form-item label="配资数量" prop="plan_count">
          <el-input v-model="form.plan_count" placeholder="配资数量"></el-input
          >台
        </el-form-item>

        <el-form-item label="开始时间" prop="start_time">
          <el-date-picker
            v-model="form.start_time"
            type="date"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="方案到期" prop="end_time">
          <el-date-picker
            v-model="form.end_time"
            type="date"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择日期"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item label="商品" required>
          <el-select
            @change="productChange"
            v-model="form.product_id"
            placeholder="选择"
            clearable
          >
            <el-option
              :key="i"
              v-for="(v, i) in productList"
              :label="v.name"
              :value="v.id"
            ></el-option>
          </el-select>
          <div>
            <el-radio-group @change="skuChange" v-model="form.product_sku_id">
              <el-radio :key="i" v-for="(v, i) in skus" :label="v.id"
                >{{ v.title }}/{{ v.price }}</el-radio
              >
            </el-radio-group>
          </div>
        </el-form-item>
        <el-form-item label="方案说明">
          <el-input
            type="textarea"
            v-model="form.plan_desc"
            placeholder="方案说明"
          ></el-input>
        </el-form-item>
        <el-form-item label="优惠金额">
          <p>方案费用：{{ price }}</p>
          <el-input
            type="number"
            v-model="form.discount"
            placeholder="优惠金额"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addServiceDialog = false">取 消</el-button>
        <el-button v-if="form.id" type="primary" @click="updateForm()"
          >修 改</el-button
        >
        <el-button v-else type="primary" @click="submitForm()">添 加</el-button>
      </span>
    </el-dialog>
  </div>
</template>
  
  <script>
import { rules } from "../rule";
import { ObjectChangedValue } from "@/js/utils";
export default {
  data() {
    return {
      form: {},
      temp: {},
      rules: rules,
      addServiceDialog: false,
      admin_id: "",
      brandList: [],
      modelList: [],
      productList: [],
      skus: [],
      price: "",
    };
  },

  mounted() {
    this.admin_id = this.$route.query.id;
    this.getProduct();
  },
  methods: {
    skuChange(v) {
      console.log(v);
      let product = {};
      this.skus.forEach((item) => {
        if (item.id == v) {
          product = item;
        }
      });

      this.price = product.price * this.form.plan_count;
    },
    productChange(v) {
      let product = {};
      this.productList.forEach((item) => {
        if (item.id == v) {
          product = item;
        }
      });
      this.skus = product.skus;
      console.log(product);
    },
    getProduct() {
      let data = {
        currentPage: 1,
        pageSize: 10,
        type: "device",
      };
      this.$get("user/product/queryInfoList", data).then((res) => {
        this.productList = res.data.data;
      });
    },

    open(info) {
      if (info && info.id) {
        this.temp = Object.assign({}, info);
        this.form = info;
      } else {
        this.form = this.temp = Object.assign({}, info);
        this.temp = {};
      }
      this.addServiceDialog = true;
    },
    updateForm() {
      this.$refs.mapForm.validate((valid) => {
        if (valid) {
          this.updateServie();
        }
      });
    },
    submitForm() {
      this.$refs.mapForm.validate((valid) => {
        if (valid) {
          this.addNew();
        }
      });
    },
    addNew() {
      let url = "/user/deviceInvestPlan/createPlan";
      this.form.admin_id = this.$route.query.id;
      this.$axios.post(url, this.form).then((res) => {
        this.$message({ type: "warning", message: "添加成功!" });
        this.addServiceDialog = false;
        this.form = {};
        this.$emit("success");
      });
    },
    updateServie() {
      let data = ObjectChangedValue(this.temp, this.form);
      if (Object.keys(data).length == 0) {
        this.addServiceDialog = false;
        this.form = {};
        this.temp = {};
        return;
      }
      data.id = this.form.id;
      let url = "/user/deviceInvestPlan/update";
      this.$axios.post(url, data).then((res) => {
        this.$message({ type: "success", message: "修改成功!" });
        this.addServiceDialog = false;
        this.form = {};
        this.temp = {};
        this.$emit("success");
      });
    },
  },
};
</script>
  
  <style lang="scss" scoped>
</style>